module.exports = __webpack_public_path__ + "static/media/52469098_2452981244777052_6867103998462132224_o.da45e5fd.jpg";